import React from "react";

export default function ModalSesionCaducada({ alAceptar }) {
  return (
    <div style={fondo}>
      <div style={modal}>
        <h3 style={{ marginTop: 0 }}>Sesión caducada</h3>
        <p>Su sesión ha expirado. Vuelva a iniciar sesión.</p>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button onClick={alAceptar} style={boton}>Aceptar</button>
        </div>
      </div>
    </div>
  );
}

const fondo = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const modal = {
  background: "#fff",
  padding: 20,
  borderRadius: 12,
  width: 360,
  boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
};

const boton = {
  padding: "8px 14px",
  borderRadius: 10,
  border: "1px solid #203c77",
  background: "#203c77",
  color: "white",
  cursor: "pointer",
};